import Data from 'data';
import { calcFrames } from 'logic/skills';
import { deepCopy } from 'utils';

function varSpeed(stats) {
  switch (stats.info.weaponClass) {
  case "hydrabow":
  case "bow": return 57.777767;
  case "ballista":
  case "crossbow": return 57.391285;
  case "repeatingcrossbow":
  case "handcrossbow": return 56.842083;
  case "dualwield": return 56.842075;
  default: return 57.692299;
  }
}

const hellcat_param = runes => ({min: 0, max: "leg_hellcatwaistguard", val: 0, name: "Bounces", buffs: false, show(rune, stats) {
  return !!stats.leg_hellcatwaistguard && (!runes || runes.indexOf(rune) >= 0);
}});

function hellcat_percent(stats, param) {
  if (stats.leg_hellcatwaistguard && param) {
    return {[Data.itemById.P43_Unique_Belt_005_x1.name]: (param >= stats.leg_hellcatwaistguard ? 800 : 50 * param)};
  }
}

export const skills = {
  hungeringarrow: {
    info(rune, stats) {
      const fpa = varSpeed(stats);
      const pierce = (stats.leg_theninthcirrisatchel_p69 ? 100 : 35 + (stats.leg_theninthcirrisatchel || 0));
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 1.55}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 1.55}, "Pierce Chance": Math.min(100, pierce + 15) + "%"}; break;
      case "a": res = {"Damage": {elem: "fir", coeff: 1.55}}; break;
      case "b": res = {"Damage": {elem: "lit", coeff: 1.55}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 1.55}, "Damage Increase per Pierce": {sum: true, "Damage": {factor: 0.7}}}; break;
      case "e": res = {"Damage": {elem: "phy", coeff: 1.55}}; break;
      default: return;
      }
      return Object.assign({"DPS": {sum: true, "Damage": {speed: 1, ias: ((stats.leg_hunterswrath || stats.leg_hunterswrath_p69) ? 30 : 0), fpa: fpa, round: "up"}}, "Damage": {}, "Pierce Chance": pierce + "%"}, res);
    },
  },
  entanglingshot: {
    info(rune, stats) {
      const fpa = varSpeed(stats);
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 2}}; break;
      case "b": res = {"Damage": {elem: "phy", coeff: 2}}; break;
      case "c": res = {"Damage": {elem: "lit", coeff: 2}, "Entangle Damage": {elem: "lit", coeff: 0.8}}; break;
      case "a": res = {"Damage": {elem: "col", coeff: 2}}; break;
      case "d": res = {"Damage": {elem: "fir", coeff: 2}}; break;
      case "e": res = {"Damage": {elem: "phy", coeff: 2}}; break;
      default: return;
      }
      return Object.assign({"DPS": {sum: true, "Damage": {speed: 1, ias: ((stats.leg_hunterswrath || stats.leg_hunterswrath_p69) ? 30 : 0), fpa: fpa, round: "up"}}}, res);
    },
  },
  bolas: {
    info: {
      "*": {"DPS": {sum: true, "Damage": {speed: 1, ias: "(leg_hunterswrath||leg_hunterswrath_p69)?30:0", fpa: 56.666666, round: "up"}}},
      x: {"Damage": {elem: "fir", coeff: 1.6}, "Secondary Damage": {elem: "fir", coeff: 1.1}},
      a: {"Damage": {elem: "fir", coeff: 1.6}, "Secondary Damage": {elem: "fir", coeff: 1.1}},
      c: {"Damage": {elem: "lit", coeff: 1.6}, "Secondary Damage": {elem: "lit", coeff: 1.1}},
      b: {"Damage": {elem: "col", coeff: 1.6}},
      d: {"Damage": {elem: "lit", coeff: 1.6}, "Secondary Damage": {elem: "lit", coeff: 1.1}},
      e: {"Damage": {elem: "fir", coeff: 2.16}, "Secondary Damage": {elem: "fir", coeff: 1.49}},
    },
  },
  evasivefire: {
    info(rune, stats) {
      const fpa = varSpeed(stats);
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 2}, "Secondary Damage": {elem: "phy", coeff: 1}}; break;
      case "a": res = {"Damage": {elem: "phy", coeff: 2}, "Secondary Damage": {elem: "phy", coeff: 1}}; break;
      case "c": res = {"Damage": {elem: "phy", coeff: 2}, "Secondary Damage": {elem: "phy", coeff: 1}, "Bomb Damage": {elem: "phy", coeff: 1.5}}; break;
      case "b": res = {"Damage": {elem: "fir", coeff: 2}, "Secondary Damage": {elem: "fir", coeff: 2}}; break;
      case "e": res = {"Damage": {elem: "col", coeff: 2}, "Secondary Damage": {elem: "col", coeff: 1}}; break;
      case "d": res = {"Damage": {elem: "lit", coeff: 2}, "Secondary Damage": {elem: "lit", coeff: 1}}; break;
      default: return;
      }
      return Object.assign({"DPS": {sum: true, "Damage": {speed: 1, ias: ((stats.leg_hunterswrath || stats.leg_hunterswrath_p69) ? 30 : 0), fpa: fpa, round: "up"}}}, res);
    },
    active: false,
    buffs: {
      a: {armor_percent: 25},
    },
  },
  grenade: {
    params: [hellcat_param()],
    info(rune, stats) {
      const res = {
        "DPS": {sum: true, "Damage": {speed: 1, ias: "(leg_hunterswrath||leg_hunterswrath_p69)?30:0", fpa: 56.470554}},
        "Damage": {elem: "fir", coeff: 1.6, passives: {grenadier: 10}},
      };
      if (rune === "b") {
        res["Damage"].coeff = 2;
      } else if (rune === "e") {
        res["Damage"].elem = "lit";
      } else if (rune === "a") {
        res["Damage"].elem = "col";
        res["Cloud Damage"] = {elem: "col", coeff: 1.2, passives: {grenadier: 10}, total: true};
      }
      res["Damage"].percent = hellcat_percent(stats, this.params[0].val);
      return res;
    },
  },
  impale: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 7.5}}; break;
      case "b": res = {"Damage": {elem: "phy", coeff: 7.5}}; break;
      case "c": res = {"Damage": {elem: "fir", coeff: 7.5}, "Burn Damage": {elem: "fir", coeff: 5, total: true}}; break;
      case "a": res = {"Damage": {elem: "col", coeff: 7.5}}; break;
      case "d": res = {"Damage": {elem: "lit", coeff: 7.5}}; break;
      case "e": res = {"Damage": {elem: "phy", coeff: 7.5, chd: 330}}; break;
      default: return;
      }
      res = Object.assign({"Cost": {cost: 20}}, res);
      const sentries = (stats.skills.sentry || stats.leg_helltrapper ? Data.skills.demonhunter.sentry.params[0].val : 0);
      if (stats.set_marauder_4pc && sentries) {
        const ext = {pet: true, sentry: true, weapon: "mainhand", percent: {"Sentry %": stats.skill_demonhunter_sentry}};
        res["Sentry Damage"] = Object.assign({}, res["Damage"], ext);
        if (res["Burn Damage"]) res["Sentry Burn Damage"] = Object.assign({}, res["Burn Damage"], ext);
      }
      if (stats.set_shadow_6pc) {
        res["First Target Bonus"] = {elem: res["Damage"].elem, coeff: 750};
        res["Subsequent Target Bonus"] = {elem: res["Damage"].elem, coeff: 250};
      }
      const total = {};
      if (res["Sentry Damage"]) total["Sentry Damage"] = {count: sentries};
      if (res["Burn Damage"]) total["Burn Damage"] = {};
      if (res["Sentry Burn Damage"]) total["Sentry Burn Damage"] = {count: sentries};
      if (Object.keys(total).length || stats.leg_holypointshot || stats.leg_holypointshot_p69) {
        total["Damage"] = {};
        if (stats.leg_holypointshot || stats.leg_holypointshot_p69) {
          for (const k in total) {
            total[k].count = (total[k].count || 1) * 3;
          }
        }
        total.sum = true;
        res["Total Damage"] = total;
        res["DPS"] = {sum: true, "Total Damage": {speed: 1, fpa: 58.064510, round: "up"}};
      } else {
        res["DPS"] = {sum: true, "Damage": {speed: 1, fpa: 58.064510, round: "up"}};
      }
      return res;
    },
  },
  rapidfire: {
    active: true,
    activeshow() {
      return false;
    },
    params: [{min: 0, max: "leg_wojahnniassaulter_p65?30:4", name: "Channeled for", buffs: false, show(rune, stats) {
               return stats.leg_wojahnniassaulter || stats.leg_wojahnniassaulter_p2 || stats.leg_wojahnniassaulter_p65;
             }},
             hellcat_param("a")],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Tick Damage": {elem: "phy", coeff: 6.85}}; break;
      case "d": res = {"Tick Damage": {elem: "fir", coeff: 6.85}}; break;
      case "e": res = {"Tick Damage": {elem: "col", coeff: 6.85}}; break;
      case "c": res = {"Tick Damage": {elem: "phy", coeff: 6.85}, "Rocket Damage": {elem: "phy", coeff: 1.45, passives: {ballistics: 100}}}; break;
      case "b": res = {"Tick Damage": {elem: "lit", coeff: 6.85}}; break;
      case "a": res = {"Tick Damage": {elem: "fir", coeff: 5.45, passives: {grenadier: 10}, percent: hellcat_percent(stats, this.params[1].val)}}; break;
      default: return;
      }
      const cost = {"Cost": {cost: (rune === "d" ? 10 : 20)}};
      if (!stats.leg_sinseekers && !stats.leg_sinseekers_p65) {
        cost["Channeling Cost"] = {cost: 6, slowest: true, fpa: (rune === "a" ? 20 : 10)};
      }
      res = Object.assign(cost, res);
      res["Tick Damage"].divide = {"Base Speed": (rune === "a" ? 3 : 6)};
      res["DPS"] = {
        sum: true,
        tip: ["Snapshots the speed of your current weapon", "Calculations are based on your slowest weapon"],
        "Tick Damage": {speed: 1, slowest: true, fpa: (rune === "a" ? 20 : 10)},
      };
      if (rune === "c") res["DPS"]["Rocket Damage"] = {aps: 1, count: 2};
      return res;
    },
    buffs(rune, stats) {
      if ((stats.leg_wojahnniassaulter || stats.leg_wojahnniassaulter_p2 || stats.leg_wojahnniassaulter_p65) && this.params[0].val) {
        return {skill_demonhunter_rapidfire: this.params[0].val * (stats.leg_wojahnniassaulter || stats.leg_wojahnniassaulter_p2 || stats.leg_wojahnniassaulter_p65)};
      }
    },
  },
  chakram: {
    params: [{min: 0, max: "maxhatred", name: "Hatred", show(rune, stats) {
               return !!stats.leg_swordofillwill;
             }}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 3.8}}; break;
      case "a": res = {"Damage": {elem: "fir", coeff: 2.2}}; break;
      case "c": res = {"Damage": {elem: "col", coeff: 5}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 3.8}}; break;
      case "b": res = {"Damage": {elem: "lit", coeff: 4}}; break;
      case "e": res = {"DPS": {elem: "phy", coeff: 2, total: true}}; break;
      default: return;
      }
      if (!stats.leg_spinesofseethinghatred) {
        res = Object.assign({"Cost": {cost: 10}}, res);
      }
      if (stats.leg_swordofillwill) {
        const pct = {[Data.itemById.P4_Unique_Sword_1H_01.name]: stats.leg_swordofillwill * this.params[0].val};
        if (res["Damage"]) res["Damage"].percent = pct;
        if (res["DPS"]) res["DPS"].percent = pct;
      }
      if (rune !== "e") {
        const sentries = (stats.skills.sentry || stats.leg_helltrapper ? Data.skills.demonhunter.sentry.params[0].val : 0);
        if (stats.set_marauder_4pc && sentries) {
          const ext = {pet: true, sentry: true, weapon: "mainhand", percent: {"Sentry %": stats.skill_demonhunter_sentry}};
          res["Sentry Damage"] = Object.assign({}, res["Damage"], ext);
        }
        const total = {};
        if (res["Sentry Damage"]) total["Sentry Damage"] = {count: sentries};
        if (Object.keys(total).length || rune === "a") {
          total.sum = true;
          total["Damage"] = {};
          res["Total Damage"] = total;
        }
        if (rune === "a") {
          total["Damage"].factor = 2;
          if (total["Sentry Damage"]) total["Sentry Damage"].factor = 2;
        }
      }
      return res;
    },
  },
  elementalarrow: {
    params: [{rune: "b", min: 2, max: 4, val: 3, name: "Target Size", buffs: false}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "fir", coeff: 3}}; break;
      case "b": res = {"Damage": {elem: "lit", coeff: 1.5}, "Average Damage": {sum: true, "Damage": {factor: this.params[0].val * 100 / ((stats.leg_augustinespanacea && 30) || stats.leg_meticulousbolts || 100)}}}; break;
      case "a": res = {"Damage": {elem: "col", coeff: 3.3}}; break;
      case "c": res = {"Damage": {elem: "fir", coeff: 3}, "Explosion Damage": {elem: "fir", coeff: 3.15, total: true}}; break;
      case "e": res = {"Damage": {elem: "lit", coeff: 3}}; break;
      case "d": res = {"Damage": {elem: "phy", coeff: 3}}; break;
      default: return;
      }
      if (stats.leg_augustinespanacea) {
        const pct = {[Data.itemById.P41_Unique_Quiver_001.name]: stats.leg_augustinespanacea};
        if (rune === "a") res["Damage"].percent = pct;
        if (rune === "c") res["Explosion Damage"].percent = pct;
        if (rune === "e") res["Damage"].percent = pct;
        if (rune === "d") res["Damage"].percent = pct;
      }
      if (!stats.leg_kridershot) {
        res = Object.assign({"Cost": {cost: 10}}, res);
      }
      const sentries = (stats.skills.sentry || stats.leg_helltrapper ? Data.skills.demonhunter.sentry.params[0].val : 0);
      if (stats.set_marauder_4pc && sentries) {
        const ext = {pet: true, sentry: true, weapon: "mainhand", percent: {"Sentry %": stats.skill_demonhunter_sentry}};
        res["Sentry Damage"] = deepCopy({}, res["Damage"], ext);
        if (res["Explosion Damage"]) {
          res["Sentry Explosion Damage"] = deepCopy({}, res["Explosion Damage"], ext);
        }
        if (rune === "b") res["Average Sentry Damage"] = {sum: true, "Sentry Damage": {factor: res["Average Damage"]["Damage"].factor}};
      }
      const total = {};
      if (res["Average Sentry Damage"]) total["Average Sentry Damage"] = {count: sentries};
      else if (res["Sentry Damage"]) total["Sentry Damage"] = {count: sentries};
      if (res["Explosion Damage"]) total["Explosion Damage"] = {};
      if (res["Sentry Explosion Damage"]) total["Sentry Explosion Damage"] = {count: sentries};
      if (Object.keys(total).length) {
        total.sum = true;
        total[rune === "b" ? "Average Damage" : "Damage"] = {};
        res["Total Damage"] = total;
        if (stats.leg_kridershot) res["DPS"] = {sum: true, "Total Damage": {speed: 1, fpa: 56.666666, round: "up"}};
      } else if (stats.leg_kridershot) {
        res["DPS"] = {sum: true};
        res["DPS"][rune === "b" ? "Average Damage" : "Damage"] = {speed: 1, fpa: 56.666666, round: "up"};
      }
      return res;
    },
  },
  caltrops: {
    info: {
      "*": {"Cost": {cost: 6, resource: "disc"}},
      a: {"Damage": {elem: "phy", weapon: "mainhand", coeff: 2.7, total: true}, "Offhand Damage": {elem: "phy", weapon: "offhand", coeff: 2.7, total: true}},
      d: {"Cost": {cost: 3, resource: "disc"}},
    },
    active: true,
    buffs: {
      e: {chc: 10},
    },
  },
  smokescreen: {
    info: {
      x: {"Cost": {cost: 14, resource: "disc"}, "Uptime": {cooldown: 1.5, duration: 1, after: true}},
      e: {"Cost": {cost: 14, resource: "disc"}, "Uptime": {cooldown: 1.5, duration: 1, after: true}},
      b: {"Cost": {cost: 14, resource: "disc"}, "Uptime": {cooldown: 1.5, duration: 1.5, after: true}},
      c: {"Cost": {cost: 14, resource: "disc"}, "Uptime": {cooldown: 1.5, duration: 1, after: true}},
      d: {"Cost": {cost: 8, resource: "disc"}, "Uptime": {cooldown: 1.5, duration: 1, after: true}},
      a: {"Uptime": {cooldown: 6, duration: 1, after: true}},
    },
    active: false,
    buffs: {
      e: {extrams: 100},
    },
  },
  shadowpower: {
    info(rune, stats) {
      if (!stats.set_shadow_4pc) {
        return {"Cost": {cost: (rune === "d" ? 8 : 14), resource: "disc"}};
      }
    },
    active: true,
    buffs(rune, stats) {
      var lph = 26821 + (stats.laek || 0) * 0.25;
      if (stats.set_shadow_4pc) {
        return {lph: lph * 2, dmgred: 35, extrams: 30};
      } else {
        switch (rune) {
        case "x": return {lph: lph};
        case "a": return {lph: lph};
        case "e": return {lph: lph * 2};
        case "d": return {lph: lph};
        case "c": return {lph: lph, dmgred: 35};
        case "b": return {lph: lph, extrams: 30};
        // no default
        }
      }
    },
  },
  vault: {
    info(rune, stats) {
      const res = {"Cost": {cost: 8, resource: (stats.set_danetta_2pc ? "hatred" : "disc")}};
      if (rune === "b") {
        delete res["Cost"];
        res["Cooldown"] = {cooldown: 6};
      }
      if (rune === "d") res["Tumble Cost"] = {cost: 4, resource: res["Cost"].resource};
      if (rune === "c") {
        res["Damage"] = {elem: "phy", weapon: "mainhand", coeff: 0.75, chc: 100/*, tip: ["Uses currently active weapon", "@Does not switch weapons"]*/};
        //res["Offhand Damage"] = {elem: "phy", weapon: "offhand", coeff: 0.75, chc: 100};
      }
      if (rune === "a") {
        res["Damage"] = {elem: "fir", weapon: "mainhand", coeff: 3, total: true/*, tip: ["Uses currently active weapon", "@Does not switch weapons"]*/};
        //res["Offhand Damage"] = {elem: "fir", weapon: "offhand", coeff: 3, total: true};
      }
      return res;
    },
  },
  preparation: {
    info: {
      x: {"Cooldown": {cooldown: 45}},
      b: {"Cooldown": {cooldown: 45}},
      a: {"Cooldown": {cooldown: 20}},
      d: {"Cooldown": {cooldown: 45}},
      c: {"Uptime": {cooldown: 45, duration: 15}},
      e: {"Cooldown": {cooldown: 45}},
    },
    passive: {
      b: {maxdisc: 20},
    },
  },
  companion: {
    info(rune, stats) {
      let count = (rune === "e" ? 2 : 1);
      if (stats.set_marauder_2pc) {
        count = 7;
      }
      if (stats.leg_thecloakofgarwulf && (rune === "c" || stats.set_marauder_2pc)) {
        count += 2;
      }
      const res = {
        "DPS": {sum: true, "Damage": {pet: 60, count: count}},
        "Damage": {elem: "phy", pet: true, aps: true, coeff: 1},
      };
      if (rune === "c" || stats.set_marauder_2pc) {
        res["Uptime"] = {duration: 10, cooldown: 30};
      } else {
        res["Cooldown"] = {cooldown: 30};
      }
      return res;
    },
    active: false,
    buffs(rune, stats) {
      if (rune === "c" || stats.set_marauder_2pc) {
        return {dmgmul: 15};
      }
    },
    passive(rune, stats) {
      if (stats.set_marauder_2pc) {
        return {hatredregen: 1, regen: 5364, resist_percent: 20, gf: 10, extrams: 10};
      } else {
        switch (rune) {
        case "d": return {hatredregen: 1};
        case "b": return {regen: 5364, resist_percent: 20};
        case "e": return {gf: 10, ms: 10};
        // no default
        }
      }
    },
  },
  markedfordeath: {
    info: {
      "*": {"Cost": {cost: 3, resource: "disc"}},
    },
    active: true,
    buffs: {
      x: {dmgtaken: 15},
      b: {dmgtaken: 15},
      c: {dmgtaken: 15},
      a: {dmgtaken: 15},
      d: {dmgtaken: 15},
      e: {dmgtaken: 15},
    },
  },
  fanofknives: {
    info: {
      x: {"Cooldown": {cooldown: 10}, "Damage": {weapon: "mainhand", elem: "phy", coeff: 6.2}},
      d: {"Cooldown": {cooldown: 15}, "Damage": {weapon: "mainhand", elem: "lit", coeff: 16}},
      e: {"Uptime": {cooldown: 10, duration: 6}, "Damage": {weapon: "mainhand", elem: "col", coeff: 6.2}},
      a: {"Cost": {cost: 30}, "Damage": {weapon: "mainhand", elem: "fir", coeff: 6.2}},
      c: {"Cooldown": {cooldown: 10}, "Damage": {weapon: "mainhand", elem: "fir", coeff: 6.2}},
      b: {"Cooldown": {cooldown: 10}, "Damage": {weapon: "mainhand", elem: "phy", coeff: 6.2}},
    },
    active: false,
    buffs: {
      e: {armor_percent: 40},
    },
  },
  spiketrap: {
    params: [{min: 0, max: stats => {
      let limit = 4;
      if (stats.passives.customengineering) limit += 1;
      if (stats.skills.spiketrap === 'd' || stats.leg_tragoulcoils_p75) limit *= 2;
      return limit;
    }, name: "Chain hits", buffs: false, show(rune, stats) {
      return stats.set_natalya_6pc;
    }}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "fir", coeff: 11.6}}; break;
      case "b": res = {"Damage": {elem: "col", coeff: 20.2}}; break;
      case "c": res = {"Damage": {elem: "fir", coeff: 19.0}}; break;
      case "a": res = {"Damage": {elem: "phy", coeff: 19.3}}; break;
      case "e": res = {"Damage": {elem: "lit", coeff: 67.0}}; break;
      case "d": res = {"Damage": {elem: "fir", coeff: 11.6}}; break;
      default: return;
      }
      if (stats.set_natalya_6pc && this.params[0].val > 1 && rune !== 'e') {
        res["Damage"].percent = (res["Damage"].percent || {});
        res["Damage"].percent[Data.itemSets.natalya.name] = (this.params[0].val - 1) * 12.5;
      }
      if (stats.leg_thedemonsdemise_p2 || stats.leg_thedemonsdemise_p75 || rune === "d" || stats.leg_tragoulcoils_p75) {
        const count = ((stats.leg_thedemonsdemise_p2 || stats.leg_thedemonsdemise_p75) && (rune || stats.leg_tragoulcoils_p75) === "d" ? 4 : 2);
        res["Total Damage"] = {sum: true, "Damage": {count: count}};
      }
      return Object.assign({"Cost": {cost: 15}}, res);
    },
  },
  sentry: {
    params: [{min: 0, max: "2+(passives.customengineering?1:0)+(leg_bombadiersrucksack||leg_bombadiersrucksack_p72?2:0)", name: "Count", buffs: false},
             {rune: "a", min: 0, max: 50, val: 30, name: "Distance", buffs: false}],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", weapon: "mainhand", pet: true, coeff: 2.8}}; break;
      case "c": res = {"Damage": {elem: "fir", weapon: "mainhand", pet: true, coeff: 2.8}, "Rocket Damage": {elem: "fir", weapon: "mainhand", pet: true, coeff: 1.2, passives: {ballistics: 100}}}; break;
      case "b": res = {"Damage": {elem: "lit", weapon: "mainhand", pet: true, coeff: 2.8}}; break;
      case "a": res = {"Damage": {elem: "phy", weapon: "mainhand", pet: true, coeff: 2.8}}; break;
      case "d": res = {"Damage": {elem: "col", weapon: "mainhand", pet: true, coeff: 2.8}}; break;
      case "e": res = {"Damage": {elem: "phy", weapon: "mainhand", pet: true, coeff: 2.8}}; break;
      default: return;
      }
      res = Object.assign({"Cost": {cost: 20}}, res);
      const count = this.params[0].val;
      res["DPS"] = {sum: true, "Damage": {pet: 54, speed: 1}};
      if (res["Rocket Damage"]) res["DPS"]["Rocket Damage"] = {pet: 54, speed: 1};
      res["Total DPS"] = {sum: true, "DPS": {count: count}};
      if (rune === "a") {
        res["Chain DPS"] = {elem: "phy", pet: true, aps: true, coeff: 3, total: true};
      }
      return res;
    },
    active: true,
    buffs: {
      e: {dmgred: 25},
    },
  },
  vengeance: {
    info: {
      "*": {"Uptime": {duration: 20, cooldown: 90, cdr: "leg_dawn"}},
      x: {"Side Guns Damage": {elem: "phy", weapon: "mainhand", coeff: 0.6}, "Homing Rockets Damage": {elem: "phy", weapon: "mainhand", coeff: 0.4, passives: {ballistics: 100}}, "Total Damage per Attack": {sum: true, "Side Guns Damage": {count: 4}, "Homing Rockets Damage": {count: 4}}},
      c: {"Side Guns Damage": {elem: "fir", weapon: "mainhand", coeff: 0.6}, "Grenades Damage": {elem: "fir", weapon: "mainhand", coeff: 1.5, passives: {grenadier: 10}}, "Total Damage per Attack": {sum: true, "Side Guns Damage": {count: 4}, "Grenades Damage": {count: 2}}},
      b: {"Side Guns Damage": {elem: "lit", weapon: "mainhand", coeff: 0.6}, "Homing Rockets Damage": {elem: "lit", weapon: "mainhand", coeff: 0.4, passives: {ballistics: 100}}, "Total Damage per Attack": {sum: true, "Side Guns Damage": {count: 4}, "Homing Rockets Damage": {count: 4}}},
      d: {"Cannon Damage": {elem: "phy", weapon: "mainhand", coeff: 2.25}},
      e: {"Side Guns Damage": {elem: "phy", weapon: "mainhand", coeff: 0.6}, "Homing Rockets Damage": {elem: "phy", weapon: "mainhand", coeff: 0.4, passives: {ballistics: 100}}, "Total Damage per Attack": {sum: true, "Side Guns Damage": {count: 4}, "Homing Rockets Damage": {count: 4}}},
      a: {"Side Guns Damage": {elem: "col", weapon: "mainhand", coeff: 0.6}, "Shadow Clone Damage": {elem: "col", weapon: "mainhand", coeff: 1.2}, "Total Damage per Attack": {sum: true, "Side Guns Damage": {count: 4}, "Shadow Clone Damage": {}}},
    },
    active: false,
    buffs(rune, stats) {
      const res = {ccr: 100, dmgmul: 40};
      if (rune === "b" || stats.leg_visageofgunes) res.dmgred = 50;
      if (rune === "e") res.hatredregen = 10;
      return res;
    },
  },
  strafe: {
    params: [hellcat_param("a")],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Tick Damage": {elem: "phy", coeff: 6.75}}; break;
      case "b": res = {"Tick Damage": {elem: "col", coeff: 6.75}, "Trail DPS": {elem: "col", coeff: 1, total: true}}; break;
      case "d": res = {"Tick Damage": {elem: "lit", coeff: 6.75}}; break;
      case "e": res = {"Tick Damage": {elem: "phy", coeff: 6.75, chd: 140}}; break;
      case "c": res = {"Tick Damage": {elem: "fir", coeff: 6.75}, "Rocket Damage": {elem: "fir", coeff: 1.3, passives: {ballistics: 100}}}; break;
      case "a": res = {"Grenade Damage": {elem: "fir", coeff: 4.6, passives: {grenadier: 10}, percent: hellcat_percent(stats, this.params[0].val)}}; break;
      default: return;
      }
      res = Object.assign({"Cost": {cost: 12, slowest: true, fpa: (rune === "a" ? 30 : 15)}}, res);
      if (res["Tick Damage"]) res["Tick Damage"].divide = {"Base Speed": 4};
      res["DPS"] = {sum: true, tip: ["Snapshots the speed of your current weapon", "Calculations are based on your slowest weapon"]};
      if (res["Tick Damage"]) res["DPS"]["Tick Damage"] = {speed: 1, slowest: true, fpa: 15};
      if (res["Rocket Damage"]) res["DPS"]["Rocket Damage"] = {speed: 1, slowest: true, fpa: 30};
      if (res["Grenade Damage"]) res["DPS"]["Grenade Damage"] = {speed: 1, slowest: true, fpa: 30};
      return res;
    },
    active: true,
    buffs(rune, stats) {
      if (stats.set_dreadlands_4pc) return {extrams: Data.itemaffixes.set_dreadlands_2pc.params[0].val * 8, dmgred: 60};
    },
  },
  multishot: {
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", coeff: 3.6}}; break;
      case "d": res = {"Damage": {elem: "lit", coeff: 3.6}}; break;
      case "b": res = {"Damage": {elem: "col", coeff: 3.6}}; break;
      case "e": res = {"Damage": {elem: "phy", coeff: 3.6}}; break;
      case "a": res = {"Damage": {elem: "phy", coeff: 5}}; break;
      case "c": res = {"Damage": {elem: "fir", coeff: 3.6}, "Rocket Damage": {elem: "fir", coeff: 3, passives: {ballistics: 100}}}; break;
      default: return;
      }
      res = Object.assign({"Cost": {cost: (rune === "d" ? 18 : 25)}}, res);
      const sentries = (stats.skills.sentry || stats.leg_helltrapper ? Data.skills.demonhunter.sentry.params[0].val : 0);
      if (stats.set_marauder_4pc && sentries) {
        var ext = {pet: true, sentry: true, weapon: "mainhand", percent: {"Sentry %": stats.skill_demonhunter_sentry}};
        res["Sentry Damage"] = Object.assign({}, res["Damage"], ext);
        if (res["Rocket Damage"]) {
          res["Sentry Rocket Damage"] = Object.assign({}, res["Rocket Damage"], ext);
        }
      }
      const total = {};
      if (res["Sentry Damage"]) total["Sentry Damage"] = {count: sentries};
      if (res["Rocket Damage"]) total["Rocket Damage"] = {};
      if (res["Sentry Rocket Damage"]) total["Sentry Rocket Damage"] = {count: sentries};
      if (Object.keys(total).length) {
        total.sum = true;
        total["Damage"] = {};
        res["Total Damage"] = total;
        res["DPS"] = {sum: true, "Total Damage": {speed: 1, ias: ((stats.leg_yangsrecurve || stats.leg_yangsrecurve_p6) ? 50 : 0), fpa: 56.666664, round: "up"}};
      } else {
        res["DPS"] = {sum: true, "Damage": {speed: 1, ias: ((stats.leg_yangsrecurve || stats.leg_yangsrecurve_p6) ? 50 : 0), fpa: 56.666664, round: "up"}};
      }

      return res;
    },
    active: true,
    buffs: {
      b: {chctaken: 8},
    },
  },
  clusterarrow: {
    params: [hellcat_param("xeca")],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "fir", coeff: 6.5}, "Grenade Damage": {elem: "fir", coeff: 2.5, passives: {grenadier: 10}}}; break;
      case "e": res = {"Damage": {elem: "lit", coeff: 6.5}, "Grenade Damage": {elem: "lit", coeff: 2.5, passives: {grenadier: 10}}}; break;
      case "b": res = {"Damage": {elem: "phy", coeff: 6.5}, "Rocket Damage": {elem: "phy", coeff: 6, passives: {ballistics: 100}}}; break;
      case "d": res = {"Damage": {elem: "col", coeff: 6.5}, "Rocket Damage": {elem: "col", coeff: 4.5, passives: {ballistics: 100}}}; break;
      case "c": res = {"Damage": {elem: "fir", coeff: 6.5}, "Grenade Damage": {elem: "fir", coeff: 6.5, passives: {grenadier:10}}}; break;
      case "a": res = {"Damage": {elem: "fir", coeff: 8.5}, "Grenade Damage": {elem: "fir", coeff: 2.5, passives: {grenadier:10}}}; break;
      default: return;
      }
      res = Object.assign({"Cost": {cost: 40}}, res);
      if (stats.leg_manticore_p6) res["Cost"].rcr = {leg_manticore_p6: 50};
      if (stats.leg_manticore) res["Cost"].rcr = {leg_manticore: stats.leg_manticore};
      if (res["Grenade Damage"]) {
        res["Grenade Damage"].percent = hellcat_percent(stats, this.params[0].val);
      }
      const sentries = (stats.skills.sentry || stats.leg_helltrapper ? Data.skills.demonhunter.sentry.params[0].val : 0);
      if (stats.set_marauder_4pc && sentries) {
        const ext = {pet: true, sentry: true, weapon: "mainhand", percent: {"Sentry %": stats.skill_demonhunter_sentry}};
        res["Sentry Damage"] = Object.assign({}, res["Damage"], ext);
        if (res["Grenade Damage"]) {
          res["Sentry Grenade Damage"] = deepCopy({}, res["Grenade Damage"]);
          delete res["Sentry Grenade Damage"].percent;
          deepCopy(res["Sentry Grenade Damage"], ext);
        }
        if (res["Rocket Damage"]) {
          res["Sentry Rocket Damage"] = Object.assign({}, res["Rocket Damage"], ext);
        }
      }
      const total = {
        sum: true,
        "Damage": {},
      };
      if (res["Sentry Damage"]) total["Sentry Damage"] = {count: sentries};
      if (res["Grenade Damage"]) total["Grenade Damage"] = {count: (rune === "c" ? 5 : 4)};
      if (res["Sentry Grenade Damage"]) total["Sentry Grenade Damage"] = {count: sentries * (rune === "c" ? 6 : 4)};
      if (res["Rocket Damage"]) total["Rocket Damage"] = {};
      if (res["Sentry Rocket Damage"]) total["Sentry Rocket Damage"] = {count: sentries};
      res["Total Damage"] = total;

      res["DPS"] = {sum: true, "Total Damage": {fpa: 58.064510, speed: 1}};

      return res;
    },
  },
  rainofvengeance: {
    params: [hellcat_param("c")],
    info(rune, stats) {
      let res;
      switch (rune) {
      case "x": res = {"Damage": {elem: "phy", weapon: "mainhand", coeff: 15, total: true}}; break;
      case "b": res = {"Damage": {elem: "phy", weapon: "mainhand", coeff: 35, total: true}}; break;
      case "a": res = {"Damage": {elem: "lit", weapon: "mainhand", coeff: 28, total: true}}; break;
      case "e": res = {"Damage": {elem: "fir", weapon: "mainhand", coeff: 46, total: true}}; break;
      case "c": res = {"Damage": {elem: "fir", weapon: "mainhand", coeff: 58, passives: {grenadier: 10}, total: true, percent: hellcat_percent(stats, this.params[0].val)}}; break;
      case "d": res = {"Damage": {elem: "col", weapon: "mainhand", coeff: 38, total: true}}; break;
      default: return;
      }
      res = Object.assign({"Cooldown": {cooldown: 30}}, res);
      if (stats.leg_crashingrain) {
        res["Crashing Beast Damage"] = {elem: res["Damage"].elem, weapon: "mainhand", coeff: stats.leg_crashingrain / 100};
      }
      // if (stats.set_natalya_2pc) {
      //   let ecd;
      //   if (stats.skills.strafe) {
      //     let reduction = 4;
      //     if (stats.skills.evasivefire) {
      //       const ef_fpa = varSpeed(stats);
      //       reduction += 4 * 60 / calcFrames(stats, ef_fpa, false, null, null, "up");
      //     }
      //     const cooldown = 30 * (1 - 0.01 * (stats.cdr || 0)) / (reduction + 1);
      //     res["Effective Cooldown (Strafe)"] = parseFloat(cooldown.toFixed(2)) + " seconds";
      //     ecd = (ecd ? Math.min(ecd, cooldown) : cooldown);
      //   }
      //   if (stats.skills.rapidfire) {
      //     const fpa = stats.skills.rapidfire === "a" ? 20 : 10;
      //     const frames = calcFrames(stats, fpa, true);
      //     const reduction = 4 * fpa / frames;
      //     const cooldown = 30 * (1 - 0.01 * (stats.cdr || 0)) / (reduction + 1);
      //     res["Effective Cooldown (Rapid Fire)"] = parseFloat(cooldown.toFixed(2)) + " seconds";
      //     ecd = (ecd ? Math.min(ecd, cooldown) : cooldown);
      //   }
      //   if (ecd) {
      //     res["Effective DPS"] = {sum: true, "Damage": {aps: 1 / ecd}};
      //     if (stats.leg_crashingrain) res["Effective DPS"]["Crashing Beast Damage"] = {aps: 1 / ecd};
      //   }
      // }
      return res;
    },
  },
};

export const passives = {
  thrillofthehunt: {
  },
  tacticaladvantage: {
  },
  bloodvengeance: {
    buffs: {maxhatred: 25},
  },
  steadyaim: {
    active: true,
    buffs: {dmgmul: 20},
  },
  culltheweak: {
    active: true,
    buffs: {dmgmul: 20},
  },
  nightstalker: {
  },
  brooding: {
    active: false,
    params: [{min: 0, max: 3, name: "Stacks"}],
    buffs(stats) {
      return {regen_percent: this.params[0].val * 3};
    },
  },
  hotpursuit: {
  },
  archery: {
    buffs(stats) {
      const res = {};
      switch (stats.info.mainhand.type) {
      case "hydrabow":
      case "bow": res.damage = 8; break;
      case "ballista":
      case "crossbow": res.chd = 50; break;
      case "repeatingcrossbow":
      case "handcrossbow": res.chc = 5; break;
      // no default
      }
      if (stats.info.offhand && (stats.info.offhand.type === "handcrossbow" || stats.info.offhand.type === "repeatingcrossbow")) {
        res.hatredregen = 1;
      }
      return res;
    },
  },
  numbingtraps: {
  },
  perfectionist: {
    buffs: {armor_percent: 10, resist_percent: 10, rcr_disc: 10},
  },
  customengineering: {
  },
  grenadier: {
    info: {"Grenade Damage": {elem: "fir", coeff: 10, passives: {grenadier: 10}}},
  },
  sharpshooter: {
    active: false,
    params: [{min: 0, max: 100, step: 4, name: "Bonus"}],
    buffs(stats) {
      return {extrachc: this.params[0].val};
    },
  },
  ballistics: {
    info: {"Rocket Damage": {elem: "phy", coeff: 1.5, passives: {ballistics: 100}}},
  },
  leech: {
    buffs(stats) {
      return {lph: 18506.5245 + 0.75 * (stats.laek || 0)};
    },
  },
  ambush: {
    active: false,
    buffs: {dmgmul: 40},
  },
  awareness: {
  },
  singleout: {
    active: false,
    buffs: {chctaken: 25},
  },
};

export const partybuffs = {
  companion: {
    runelist: "bc",
    multiple: true,
    buffs(stats) {
      const buffs = {};
      if (this.runevals.b) {
        buffs.regen = 5364;
        buffs.resist_percent = 20;
      }
      if (this.runevals.c) buffs.dmgmul = 15;
      return buffs;
    },
  },
  sentry: {
    runelist: "e",
  },
  multishot: {
    runelist: "b",
  },
  markedfordeath: {
    runelist: "*",
  },
};
